export type DialogState = {
  isDialogOpened: boolean;
  dialogPage: DialogOption;
};

export enum DialogOption {
  BlankPage = "BlankPage",
  ConnectCarrierAccountPage = "ConnectCarrierAccountPage",
  ConnectYourAccountPage = "ConnectYourAccountPage",
  UpdateYourAccountPage = "UpdateYourAccountPage",
  UpdateShipVistaAccountPage = "UpdateShipVistaAccountPage",
  ConnectStorePage = "ConnectStorePage",
  StoreDetailFramePage = "StoreDetailFramePage",
  EditCurrentStorePage = "EditCurrentStorePage",
}